import type { FC } from 'react';

import type { AppProps } from '@eneco/next';
import { SessionProvider } from 'next-auth/react';


const MainApp: FC<AppProps> = ({ Component, pageProps: { session, ...pageProps }, router }) => {
  return (
    <SessionProvider session={session} basePath={`${router.basePath}/api/auth`}>
      <Component {...pageProps} />
    </SessionProvider>
  );
};

export default MainApp;
